/* ============================================================
   PARFUMLOVERS — Historie-Section „Der Zeitstrahl" (1b)
   Vanilla-JS-Modul: Zeitstrahl-Scrubber, Count-up, Scroll-
   Reveal, Weltkarte (d3 + world-atlas).
   Progressive Enhancement: ohne JS bleiben alle Kapitel und
   die finalen Kennzahlen sichtbar.
   ============================================================ */
(function () {
  'use strict';

  var EASE_DELAY_STEP = 90;   /* ms Stagger innerhalb eines Frames */
  var COUNT_DURATION = 1600;  /* ms */

  var CITIES = [
    { name: 'Frankfurt', lon: 8.6821, lat: 50.1109, lbl: false },
    { name: 'Bologna', lon: 11.3426, lat: 44.4949, lbl: false },
    { name: 'Paris', lon: 2.3522, lat: 48.8566, lbl: false },
    { name: 'Las Vegas', lon: -115.1398, lat: 36.1699, lbl: true, dx: 0, dy: -12, anchor: 'middle' },
    { name: 'Rio de Janeiro', lon: -43.1729, lat: -22.9068, lbl: true, dx: 0, dy: 20, anchor: 'middle' },
    { name: 'Hongkong', lon: 114.1694, lat: 22.3193, lbl: true, dx: 9, dy: 15, anchor: 'start' },
    { name: 'Shanghai', lon: 121.4737, lat: 31.2304, lbl: true, dx: 9, dy: -7, anchor: 'start' },
    { name: 'Dubai', lon: 55.2708, lat: 25.2048, lbl: true, dx: 0, dy: 20, anchor: 'middle' },
    { name: 'Moskau', lon: 37.6173, lat: 55.7558, lbl: true, dx: 0, dy: -11, anchor: 'middle' }
  ];
  var HOME = { name: 'Köln', lon: 6.9603, lat: 50.9375 };
  var WORLD_ATLAS_URL = 'https://cdn.jsdelivr.net/npm/world-atlas@2.0.2/countries-110m.json';

  /* ---- Zeitstrahl (Scrubber) -------------------------------- */
  function initTimeline(root) {
    var track = root.querySelector('[data-plh-track]');
    var chapters = root.querySelector('[data-plh-chapters]');
    if (!track || !chapters) return;
    var panels = chapters.querySelectorAll('[data-plh-panel]');
    var stops = Array.prototype.slice.call(track.querySelectorAll('[data-plh-stop]'));
    var fill = track.querySelector('.plh-track-fill');
    var handle = track.querySelector('.plh-track-handle');
    var n = panels.length;
    if (!n) return;

    chapters.classList.add('is-js');
    var idx = 0, dragging = false;

    function setIdx(i) {
      idx = Math.max(0, Math.min(n - 1, i));
      var pct = (n > 1 ? (idx / (n - 1) * 100) : 0) + '%';
      if (fill) fill.style.width = pct;
      if (handle) handle.style.left = pct;
      stops.forEach(function (s, j) {
        s.classList.toggle('is-past', j <= idx);
        s.classList.toggle('is-act', j === idx);
        s.setAttribute('aria-pressed', j === idx ? 'true' : 'false');
      });
      panels.forEach(function (p, j) {
        p.classList.toggle('is-act', j === idx);
      });
    }

    function scrub(e) {
      var r = track.getBoundingClientRect();
      setIdx(Math.round((e.clientX - r.left) / r.width * (n - 1)));
    }

    track.addEventListener('pointerdown', function (e) {
      dragging = true;
      try { track.setPointerCapture(e.pointerId); } catch (_) {}
      scrub(e);
    });
    track.addEventListener('pointermove', function (e) { if (dragging) scrub(e); });
    track.addEventListener('pointerup', function () { dragging = false; });
    track.addEventListener('pointercancel', function () { dragging = false; });

    stops.forEach(function (s, j) {
      s.addEventListener('click', function () { setIdx(j); });
    });
    root.querySelectorAll('[data-plh-prev]').forEach(function (b) {
      b.addEventListener('click', function () { setIdx(idx - 1); });
    });
    root.querySelectorAll('[data-plh-next]').forEach(function (b) {
      b.addEventListener('click', function () { setIdx(idx + 1); });
    });

    setIdx(0);
  }

  /* ---- Count-up --------------------------------------------- */
  function fmt(v, f) {
    if (f === 'mio') return (v / 1e6).toLocaleString('de-DE', { maximumFractionDigits: 1 }) + ' Mio.';
    return Math.round(v).toLocaleString('de-DE');
  }

  function initCountup(root) {
    var els = root.querySelectorAll('[data-plh-count]');
    if (!els.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting || en.target._plhDone) return;
        en.target._plhDone = true;
        io.unobserve(en.target);
        var el = en.target;
        var target = +el.getAttribute('data-plh-count');
        var f = el.getAttribute('data-plh-fmt');
        var suf = el.getAttribute('data-plh-suffix') || '';
        var t0 = performance.now();
        (function step(now) {
          var t = Math.min(1, (now - t0) / COUNT_DURATION);
          var e = 1 - Math.pow(1 - t, 3);
          el.textContent = fmt(target * e, f) + (t >= 1 ? suf : '');
          if (t < 1) requestAnimationFrame(step);
        })(t0);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---- Scroll-Reveal ---------------------------------------- */
  /* Versteckt wird nur per JS — Fallback-sicher. Nur Elemente,
     die beim Load unterhalb des Viewports liegen. */
  function initReveal(root) {
    if (!('IntersectionObserver' in window)) return;
    var pending = new Set();
    var io = new IntersectionObserver(function (entries) {
      var vis = entries.filter(function (e) { return e.isIntersecting; });
      vis.forEach(function (en, i) {
        en.target.style.transitionDelay = (i * EASE_DELAY_STEP) + 'ms';
        en.target.classList.remove('out');
        en.target.classList.add('in');
        pending.delete(en.target);
        io.unobserve(en.target);
      });
    }, { threshold: 0.12 });
    root.querySelectorAll('[data-plh-rev]').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top > window.innerHeight * 0.95) {
        el.classList.add('out');
        pending.add(el);
        io.observe(el);
      }
    });
    /* Sicherheitsnetz: falls IO-Callbacks ausbleiben, nach 2.5 s alles einblenden */
    setTimeout(function () {
      if (!pending.size) return;
      var fired = false;
      pending.forEach(function (el) { if (el.classList.contains('in')) fired = true; });
      if (!fired) pending.forEach(function (el) { el.classList.remove('out'); el.classList.add('in'); });
    }, 2500);
  }

  /* ---- Weltkarte (d3 + topojson-client + world-atlas) ------- */
  function mapError(root) {
    var load = root.querySelector('.plh-map-load');
    if (load) load.textContent = 'Karte offline — alle Standorte siehe Liste unten.';
  }

  function drawMap(root, opts) {
    var c = root.querySelector('[data-plh-map]');
    if (!c) return;
    fetch(WORLD_ATLAS_URL)
      .then(function (r) { return r.json(); })
      .then(function (topo) {
        var feats = topojson.feature(topo, topo.objects.countries).features
          .filter(function (f) { return String(f.id) !== '010'; }); /* Antarktis raus */
        c.innerHTML = '';
        var w = c.clientWidth || 1150;
        var h = Math.round(w * 0.48);
        var svg = d3.select(c).append('svg')
          .attr('viewBox', '0 0 ' + w + ' ' + h)
          .attr('role', 'img')
          .attr('aria-label', 'Weltkarte mit den neun Messestandorten und der Homebase Köln')
          .style('width', '100%').style('height', 'auto').style('display', 'block');
        var proj = d3.geoNaturalEarth1().fitSize([w, h], { type: 'FeatureCollection', features: feats });
        var path = d3.geoPath(proj);
        svg.append('g').selectAll('path').data(feats).join('path')
          .attr('d', path).attr('fill', '#E4DED6').attr('stroke', '#FFFFFF').attr('stroke-width', 0.6);
        if (opts.arcs) {
          svg.append('g').selectAll('path').data(CITIES).join('path')
            .attr('d', function (d) {
              return path({ type: 'LineString', coordinates: [[HOME.lon, HOME.lat], [d.lon, d.lat]] });
            })
            .attr('fill', 'none').attr('stroke', '#9C0045').attr('stroke-width', 1)
            .attr('stroke-dasharray', '2 5').attr('opacity', 0.35);
        }
        var g = svg.append('g');
        CITIES.forEach(function (d, i) {
          var p = proj([d.lon, d.lat]), x = p[0], y = p[1];
          if (opts.motion) {
            g.append('circle').attr('cx', x).attr('cy', y).attr('r', 4.5)
              .attr('fill', '#9C0045').attr('opacity', 0.45)
              .style('transform-box', 'fill-box').style('transform-origin', 'center')
              .style('animation', 'plhPulse 2.6s ease-out ' + (i * 0.25) + 's infinite');
          }
          g.append('circle').attr('cx', x).attr('cy', y).attr('r', 4.5)
            .attr('fill', '#9C0045').attr('stroke', '#FFFFFF').attr('stroke-width', 1.5)
            .append('title').text(d.name);
          if (d.lbl) {
            g.append('text').attr('x', x + (d.dx || 0)).attr('y', y + (d.dy || 0))
              .attr('text-anchor', d.anchor || 'middle')
              .attr('font-family', 'IvyStyle Sans, sans-serif').attr('font-size', 11.5)
              .attr('fill', '#6b645c').text(d.name);
          }
        });
        var hp = proj([HOME.lon, HOME.lat]), hx = hp[0], hy = hp[1];
        if (opts.heartUrl) {
          g.append('image').attr('href', opts.heartUrl)
            .attr('x', hx - 12).attr('y', hy - 12).attr('width', 24).attr('height', 24);
        }
        g.append('text').attr('x', hx).attr('y', hy - 16).attr('text-anchor', 'middle')
          .attr('font-family', 'IvyStyle Sans, sans-serif').attr('font-size', 12.5)
          .attr('font-weight', 700).attr('fill', '#9C0045').text(HOME.name);
      })
      .catch(function () { mapError(root); });
  }

  function initMap(root, opts) {
    if (!root.querySelector('[data-plh-map]')) return;
    (function waitD3(t0) {
      if (window.d3 && window.topojson) drawMap(root, opts);
      else if (Date.now() - t0 < 12000) setTimeout(function () { waitD3(t0); }, 250);
      else mapError(root);
    })(Date.now());
  }

  /* ---- Init pro Section-Instanz ----------------------------- */
  function initSection(root) {
    if (root.hasAttribute('data-plh-init')) return;
    root.setAttribute('data-plh-init', '');
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var motion = root.getAttribute('data-motion') === 'true' && !reduced;
    initTimeline(root);
    if (motion) {
      initCountup(root);
      initReveal(root);
    }
    initMap(root, {
      arcs: root.getAttribute('data-arcs') === 'true',
      motion: motion,
      heartUrl: root.getAttribute('data-heart')
    });
  }

  function initAll() {
    document.querySelectorAll('[data-plh]').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  /* Shopify Theme-Editor: Section neu initialisieren, wenn sie
     im Customizer neu geladen wird. */
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target.querySelector('[data-plh]');
    if (root) initSection(root);
  });
})();